import {ApiClientInterface} from "./clients";
import {Collection, TransactionInfo} from "./models";

export class TransactionInfoProvider {
  constructor(private readonly apiClient: ApiClientInterface) {}

  public async getAll(): Promise<Collection<TransactionInfo>> {
    return this.apiClient.get("");
  }
}